document.querySelectorAll('[data-plugin-collection]').forEach((root) => {
  const toolbar = root.querySelector('[data-plugin-search]');
  const input = toolbar.querySelector('input');
  const cards = [...root.querySelectorAll('[data-plugin-card]')];
  const count = root.querySelector('[data-plugin-count]');
  const empty = root.querySelector('[data-plugin-empty]');
  const update = () => {
    const query = input.value.trim().toLocaleLowerCase();
    let visible = 0;
    cards.forEach((card) => { card.hidden = !card.textContent.toLocaleLowerCase().includes(query); if (!card.hidden) visible++; });
    count.textContent = `${visible} ${visible === 1 ? 'plugin' : 'plugins'}`;
    empty.hidden = visible !== 0;
  };
  const status = root.querySelector('[data-plugin-feed-status]');
  const downloads = root.hasAttribute('data-plugin-downloads');
  toolbar.hidden = false;
  input.addEventListener('input', update);
  update();
  const el = (tag, text, className) => { const node = document.createElement(tag); if (text) node.textContent = text; if (className) node.className = className; return node; };
  const link = (text, url) => {
    const parsed = new URL(url, location.origin);
    if (parsed.protocol !== 'https:' || !['live.gotak.dev', 'getgotak.com'].includes(parsed.hostname)) throw new Error('Invalid catalog link');
    const node = el('a', text); node.href = parsed.href; return node;
  };
  if (downloads) { status.hidden = false; status.textContent = 'Loading current download options…'; }
  fetch('https://live.gotak.dev/api/marketplace/storefront', { credentials: 'omit', signal: AbortSignal.timeout(15000) })
    .then(response => { if (!response.ok) throw new Error('Catalog unavailable'); return response.json(); })
    .then(({ plugins }) => {
      if (!Array.isArray(plugins)) throw new Error('Catalog unavailable');
      // Only enhance existing curated cards. Feed records can never add collection entries.
      cards.forEach(card => {
        const product = plugins.find(p => p.handle === card.dataset.pluginHandle && p.available);
        if (!product) return;
        const description = card.querySelector('.gk-plugins__body p');
        if (product.description && description) description.textContent = product.description;
        if (!downloads) return;
        const oldLink = card.querySelector('a');
        const body = card.querySelector('.gk-plugins__body');
        body.querySelector('span')?.remove();
        const actions = el('div', '', 'gk-plugins__download-actions');
        actions.append(link(product.takosOnly ? 'Sign in to download' : product.paid ? 'View license options' : 'Plugin details', product.detailUrl));
        (product.channels || []).forEach(channel => actions.append(link(channel.requiresLicense ? 'Access licensed download' : channel.label, channel.url)));
        if (product.latestVersion) body.append(el('p', `Latest version: ${product.latestVersion}`));
        if (product.builds?.length) {
          const versions = el('details', '', 'gk-plugins__versions');
          versions.append(el('summary', `Available versions (${product.builds.length})`));
          product.builds.forEach(build => versions.append(link(`${build.version} · ${build.channel}${build.requiresLicense ? ' · License access' : ' · Download'}`, build.url)));
          body.append(versions);
        }
        body.append(actions);
        oldLink.replaceWith(...oldLink.childNodes);
      });
      status.hidden = true;
      update();
    })
    .catch(() => {
      if (!downloads) return; // Keep the server-rendered collection usable when the feed is down.
      status.hidden = false; status.textContent = 'Current download information is temporarily unavailable. ';
      status.append(link('Open the download portal', 'https://live.gotak.dev/plugins'));
    });
});
